export default {
    accept:"Acceptera",
    average:"Medeltal",
    cancel:"Annullera",
    categories:"Kategorier",
    categoryDist:"Kategori Distribution",
    clear:"Tömma",
    clickOnDate:"Klicka på ett datum för att tilldela en klass",
    confirmDel:"Är du säker på att du vill radera den här klassen?",
    contact:"Ta Kontakt",
    contactDes: 'Vårt serviceteam tar kontakt inom 24 timmar från det att du gjort en felanmälan. Om felanmälan görs på veckoslut besvarar vi följande vardag.',
    copy:"Kopiera",
    copiedWeek:"Kopierad vecka",
    delete:"Radera",
    devStatus:"Mina enheter",
    dislikes:"Ogillar",
    dislikesPeriod:"Ogillar den här perioden",
    likes: 'Gillar',
    likesPeriod:"Gillar den här perioden",
    logoff:"Logga ut",
    maintenance:"Planerat underhåll på onsdagen den 4.7.18 från 7:00 till 11:00.",
    modify:"Ändra",
    mostLikedVideo:"Mest gillade video",
    mostViewedCategory:"Mest visade kategori",
    mostViewedVideo:"Mest visade video",
    paste:"Klistra",
    save:"Spara", 
    summary:"Resume",  
    views: 'Visningar',
    viewsPeriod:"Visningar den här perioden",
    week: 'Vecka',
    weekControl:"Veckontroll",
    welcome:"Välkommen",
}


// WEBPACK FOOTER //
// ./src/lang/sv/index.js